import en from "./locales/en.json";
import es from "./locales/es.json";
import ca from "./locales/ca-es.json";
import it from "./locales/it.json";
import { createI18n } from "vue-i18n";

const browserLanguage = navigator.language.split("-")[0];

const messages = { en, es, ca, it };

export default createI18n({
  legacy: true,
  locale: browserLanguage in messages ? browserLanguage : "en",
  fallbackLocale: "en",
  globalInjection: true,
  silentFallbackWarn: true,
  messages,
});
